import React, { useState } from 'react';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Website enquiry from ${form.name}`);
    const body = encodeURIComponent(`${form.message}\n\nFrom: ${form.name} (${form.email})`);
    window.location.href = `mailto:hello@venividilaundry.co.uk?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="container" style={{ maxWidth: '900px' }}>
      <h1 className="section-title">Get in touch</h1>
      <p className="section-sub">Questions, special requests, or just saying hello — we'd love to hear from you.</p>

      <div className="booking-layout">
        <div className="card">
          <h3 style={{ marginBottom: '1rem' }}>Send us a message</h3>
          <form onSubmit={submit}>
            <div className="form-group">
              <label>Your name</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea rows="5" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required />
            </div>
            <button className="btn btn-accent btn-block">Send message</button>
            {sent && <div className="success-message">Thanks! Your email app should have opened — if not, drop us a line at hello@venividilaundry.co.uk.</div>}
          </form>
        </div>

        <aside className="booking-summary">
          <div className="card">
            <h3 style={{ marginBottom: '1rem' }}>Other ways to reach us</h3>
            <p style={{ marginBottom: '0.8rem' }}>📧 <a href="mailto:hello@venividilaundry.co.uk">hello@venividilaundry.co.uk</a></p>
            <p style={{ marginBottom: '0.8rem' }}>📞 <a href="tel:+440000000000">Give us a call</a></p>
            <p style={{ marginBottom: '1rem', color: 'var(--ink-soft)' }}>
              🗺️ Serving South West &amp; Central London, Heathrow, Staines and Weybridge.
            </p>
            <p style={{ fontSize: '0.9rem', color: 'var(--ink-soft)' }}>We aim to reply within one working day.</p>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Contact;
